import { LearningUnitEntity } from '../learning-unit/learning-unit-entity';
import { Relation } from '../core/decorators/relation.decorator';
import { BaseEntity } from '../core/entities/base.entity';
import { RelationRef } from '../core/types/entity-types';
import { ConsumerEntity } from '../consumer/consumer.entity';
import { SubjectEntity } from '../subject/subject.entity';
import { SchoolClassEntity } from '../core/global-enums/school-class/school-class.entity';
import { ConsumerData } from '../core/types';

export class ModuleEntity extends BaseEntity {
  title!: string;
  status!: string;

  description?: string;
  preTitle?: string;
  preview?: string[];
  consumerData?: ConsumerData;
  content?: string[];
  order?: string;
  learning_unit_order?: string[];
  created_at?: Date;

  @Relation()
  learningUnits?: RelationRef<LearningUnitEntity>[];

  @Relation()
  consumer?: RelationRef<ConsumerEntity>[];

  @Relation()
  subjects?: RelationRef<SubjectEntity>[];

  @Relation()
  schoolClasses?: RelationRef<SchoolClassEntity>[];
}
